import { AdjustmentSourceEnumType } from 'graphQL/hatostore/generate/operations'

export enum MediaTypeEnum {
  IMAGE = 'Image',
  VIDEO = 'Video',
}

export const getTypeImageFromExtension = (path) => {
  let type = MediaTypeEnum.IMAGE
  var regexVdo = /\.mp4/
  if (regexVdo.test(path)) {
    type = MediaTypeEnum.VIDEO
  }

  return type
}

interface ImageSrcOption {
  img: string
  hires2x: boolean
  hires3x: boolean
}

export const getSrcSetStr = ({ img, hires2x, hires3x }: ImageSrcOption) => {
  let srcSetStr = ''
  let imgSplitData: string[] = []
  if (img && process.env.PUBLIC_URL) {
    imgSplitData = img.replace(process.env.PUBLIC_URL, '').split('.')
    const imgPath = imgSplitData[0]
    const imgExtension = imgSplitData[1]
    if (hires2x || hires3x) {
      srcSetStr = `${process.env.PUBLIC_URL}${imgPath}.${imgExtension} 1x`
    }

    if (hires2x) {
      srcSetStr += `, ${process.env.PUBLIC_URL}${imgPath}@2x.${imgExtension} 2x`
    }

    if (hires3x) {
      srcSetStr += `, ${process.env.PUBLIC_URL}${imgPath}@3x.${imgExtension} 3x`
    }
  }

  return srcSetStr
}

const getImageName = (imagePath: string, imageType: string, size: number) => {
  if (size === 1) {
    return `${imagePath} ${size}x`
  }
  return `${imagePath.replace(`.${imageType}`, `@${size}x.${imageType}`)} ${size}x`
}

export const generateSrcSet = (imagePath: string, imageType: string, size = '3x') => {
  if (size === '2x') return [1, 2].map((_size) => getImageName(imagePath, imageType, _size)).join(',')
  return [1, 2, 3].map((_size) => getImageName(imagePath, imageType, _size)).join(',')
}

interface ResizableURLOptions {
  width: string
  height: string
  formatType?: string
}

interface Image {
  resizableURL: string
}
const placeholderProduct = `${process.env.PUBLIC_URL}/assets/placeholder-product-img.png`

export const getResizableURL = (
  images: Image[],
  { width, height, formatType = '' }: ResizableURLOptions,
  defaultImage = placeholderProduct
) => {
  if (images.length === 0) return defaultImage

  const { resizableURL } = images[0]
  return resizableURL.replace('{width}', width).replace('{height}', `${height}${formatType}`)
}

/**
 * This function will be deprecated later.
 * Use getResizableURL instead.
 */
export const getImageResizeableURL = (
  images: { resizeableURL: string }[],
  { width, height, formatType = '' }: ResizableURLOptions,
  defaultImage = placeholderProduct
) => {
  if (images.length === 0) return defaultImage

  const { resizeableURL } = images[0]
  return resizeableURL.replace('{width}', width).replace('{height}', `${height}${formatType}`)
}

interface FPCampaignImageResolution {
  defaultResolution: { width: string; height: string }
  highResolution: { width: string; height: string }
}

export const generateFPCampaignImage = (
  images: Image[],
  resolution: FPCampaignImageResolution,
  defaultCampaignImage: string
) => {
  const { defaultResolution, highResolution } = resolution
  const image1x = getResizableURL(images, { ...defaultResolution }, defaultCampaignImage)
  const highResolutionImg = getResizableURL(images, { ...highResolution }, defaultCampaignImage)
  const srcSetImage =
    images.length > 0 ? `${image1x}, ${highResolutionImg} 2x, ${highResolutionImg} 3x` : defaultCampaignImage
  return { thumbnailImageURL: image1x, srcSetImage }
}

interface GetCouponThumbnailURLOptions {
  coupon: {
    source: AdjustmentSourceEnumType
    promotion?: {
      images: Image[]
    }
    memberCoupon?: {
      promotion?: {
        images: { resizeableURL: string }[]
      }
    }
  }
  width: string
  height: string
}

export const getCouponThumbnailURL = ({
  coupon,
  width = '140',
  height = '140',
}: GetCouponThumbnailURLOptions): string => {
  if (coupon.source !== AdjustmentSourceEnumType.Promotion && coupon.source !== AdjustmentSourceEnumType.MemberCoupon) {
    return ''
  }

  let thumbnailImageURL = ''

  if (coupon.source === AdjustmentSourceEnumType.Promotion && coupon.promotion?.images?.length) {
    thumbnailImageURL = getResizableURL(coupon.promotion.images, { width, height })
    return thumbnailImageURL
  }

  if (coupon.source === AdjustmentSourceEnumType.MemberCoupon) {
    const memberCouponImages = coupon.memberCoupon?.promotion?.images
    const promotionImages = coupon.promotion?.images

    if (memberCouponImages?.length) {
      thumbnailImageURL = getImageResizeableURL(memberCouponImages, { width, height })
    }
    if (promotionImages?.length) {
      thumbnailImageURL = getResizableURL(promotionImages, { width, height })
    }
  }

  return thumbnailImageURL
}
